module.exports = __webpack_public_path__ + "media/images/fancybox_sprite-7b8e2ce6af56d812aac39e65834c9dd9.png";